import axios from 'axios';
import { AccountCompany } from 'contexts/account/types/account-company.type';

// GET
// /ewosapi/v1/me/granted/company/{globalCompanyId}
export const getCompany = async (globalCompanyId: string): Promise<AccountCompany> => {
  const res = await axios.get(`/ewosapi/v1/me/granted/company/${globalCompanyId}`);
  return res.data;
};
